/* Luvia native rebuild — small runtime for variant selection + click-to-play video.
   Add-to-cart itself is handled by the theme's own <product-form> element + cart drawer. */
(function () {
  'use strict';

  // ---- Variant selector: clicking a version card updates the form's hidden variant id ----
  function initBuybox(root) {
    var form = root.querySelector('form[data-type="add-to-cart-form"]') || root.querySelector('form');
    var idInput = root.querySelector('.product-variant-id');
    var options = root.querySelectorAll('[data-lv-variant]');
    if (!options.length || !idInput) return;

    // Variant deep links (Google Shopping): only flagged on the product's own page with real,
    // distinct versions — never the homepage buy box or the collagen quantity ladder.
    var deeplink = root.hasAttribute('data-lv-deeplink');

    function select(card, fromUser) {
      options.forEach(function (o) {
        var on = o === card;
        o.classList.toggle('is-selected', on);
        o.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      idInput.value = card.getAttribute('data-lv-variant');
      // Quantity ladders (collagen mask): every card is the SAME variant and differs only by
      // how many go in the cart, with a Shopify AUTOMATIC discount doing the saving. Absent
      // the attribute this stays 1, so normal variant cards behave exactly as before.
      var qtyInput = root.querySelector('.lv-ph__qty');
      if (qtyInput) qtyInput.value = card.getAttribute('data-lv-qty') || '1';
      // update any price mirrors in the ATC button
      var price = card.getAttribute('data-lv-price');
      root.querySelectorAll('[data-lv-price-target]').forEach(function (el) {
        if (price) el.textContent = price;
      });
      // The anniversary bundle is "this variant + the mask", so its price, its
      // compare-at, its saving and its image all depend on which version is selected.
      // Each variant card carries the bundle values it implies.
      // NB: the SOURCE attributes live on the variant card and the TARGET hooks use
      // distinct `-out-` names. They must never collide, or querySelector finds the
      // variant card itself and textContent wipes out the card's markup.
      var map = {
        'data-lv-bundle-price': '[data-lv-out-bundle-price]',
        'data-lv-bundle-compare': '[data-lv-out-bundle-compare]',
        'data-lv-bundle-save': '[data-lv-out-bundle-save]'
      };
      // Where a variant has no bundle override configured, fall back to the section
      // default rather than leaving the previously-selected variant's value on screen.
      // Looked up on the DOCUMENT, not inside the buy box: on the PDP the bundle block sits
      // in the buy box, but on the homepage it is a separate section further down the page.
      Object.keys(map).forEach(function (attr) {
        var el = document.querySelector(map[attr]);
        if (!el) return;
        if (el.dataset.lvDefault === undefined) el.dataset.lvDefault = el.textContent;
        el.textContent = card.getAttribute(attr) || el.dataset.lvDefault;
      });
      // Announce the selection so sections OUTSIDE the buy box can react (the electrode
      // grid swaps its art per version). A document-level event keeps those sections
      // decoupled — they never reach into the hero's DOM.
      var idx = Array.prototype.indexOf.call(options, card);
      document.dispatchEvent(new CustomEvent('lv:variant-change', {
        detail: {
          index: idx,
          id: card.getAttribute('data-lv-variant'),
          hero: card.getAttribute('data-lv-hero'),
          // Already money-formatted by Liquid, so Shopify Markets has converted it to the
          // visitor's currency. Down-page CTAs mirror this string — never re-format it in JS.
          price: card.getAttribute('data-lv-price')
        }
      }));

      // replaceState, not pushState: a version click is not a page, so Back still leaves the PDP.
      if (deeplink && fromUser && window.history && history.replaceState) {
        var url = new URL(window.location.href);
        // On the old-handle alias page the card sells the -dd variant, but the URL must carry
        // this page's own variant id (data-lv-url-variant) or it would not resolve on reload.
        url.searchParams.set('variant', card.getAttribute('data-lv-url-variant') || card.getAttribute('data-lv-variant'));
        history.replaceState(history.state, '', url.toString());
      }

      var bimgEl = root.querySelector('[data-lv-out-bundle-img]');
      if (bimgEl) {
        if (bimgEl.dataset.lvDefault === undefined) bimgEl.dataset.lvDefault = bimgEl.src;
        bimgEl.src = card.getAttribute('data-lv-bundle-image') || bimgEl.dataset.lvDefault;
      }
    }

    options.forEach(function (card) {
      card.setAttribute('role', 'radio');
      card.addEventListener('click', function () { select(card, true); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(card, true); }
      });
    });

    // select the pre-marked default (or first)
    // Liquid already marks the ?variant= card as selected; reading the URL here too keeps the
    // page right if it is ever served from a cache that ignored the query string.
    var pre = root.querySelector('[data-lv-variant].is-selected') || options[0];
    var urlVid = deeplink && new URLSearchParams(window.location.search).get('variant');
    if (urlVid) {
      options.forEach(function (o) {
        if ((o.getAttribute('data-lv-url-variant') || o.getAttribute('data-lv-variant')) === urlVid) pre = o;
      });
    }
    if (pre) select(pre);

    // ---- Bundle add-on ----
    // The anniversary bundle is two real line items (wand variant + mask), not a bundle
    // product; a Shopify AUTOMATIC discount then fires because both are in the cart. The
    // theme's <product-form> can only post one item, so when the bundle box is ticked we
    // take over the submit and POST both via /cart/add.js, then hand back to the theme so
    // its cart drawer opens exactly as it normally would.
    var bundleBox = root.querySelector('[data-lv-bundle]');
    if (form && bundleBox && !form.dataset.lvBundleBound) {
      form.dataset.lvBundleBound = '1';
      // CAPTURE on the document, not a listener on the form: <product-form> has its own
      // submit handler bound to the form, and a second handler there still lets the theme
      // post the wand on its own — the wand landed in the cart TWICE (qty 2 wand, qty 1
      // mask). Capturing at the document runs before any listener on the form, so
      // stopImmediatePropagation keeps the theme out of it entirely.
      document.addEventListener('submit', function (e) {
        if (e.target !== form || !bundleBox.checked) return;  // untouched → normal submit
        var maskId = bundleBox.getAttribute('data-lv-bundle-variant');
        if (!maskId) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        addToCart([idInput.value, maskId], form.querySelector('[name="add"]'));
      }, true);
    }
  }

  // ---- Add several variants in one request, then hand back to the theme's cart drawer ----
  // Used by both bundle entry points (the PDP buy-box tick box and the homepage bundle card).
  // Shopify applies the automatic bundle discount because both line items land in the cart.
  function addToCart(ids, btn) {
    var items = ids.filter(Boolean).map(function (id) { return { id: Number(id), quantity: 1 }; });
    if (!items.length) return;
    if (btn) btn.setAttribute('aria-busy', 'true');

    // The drawer's markup is rendered by Liquid at page load, so after a background add it
    // still says "your cart is empty" — the items are really in the cart, the drawer just
    // never re-rendered. Asking /cart/add.js for the drawer's own sections and handing them
    // to renderContents() is exactly what the theme's own add-to-cart does.
    var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var payload = { items: items };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      payload.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      payload.sections_url = window.location.pathname;
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        // Announce the change first, so the cart bubble and any listening app update too.
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'lv-bundle' });
        }
        if (drawer && typeof drawer.renderContents === 'function' && state && state.sections) {
          // `is-empty` is baked onto the drawer element by Liquid when the page was served.
          // renderContents swaps the inner HTML but leaves that class, which hides the items
          // we just added — so clear it ourselves. renderContents also opens the drawer.
          drawer.classList.remove('is-empty');
          drawer.renderContents(state);
          return;
        }
        if (drawer && typeof drawer.open === 'function') drawer.open();
        else window.location.href = '/cart';
      })
      .catch(function () { window.location.href = '/cart'; })
      .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }

  // ---- Bundle card CTA (homepage): adds the wand version the buy box currently has
  // selected PLUS the mask, in one request, and opens the drawer. It reads the live
  // variant id out of the buy box rather than keeping its own copy, so the card can never
  // drift from what the visitor picked. With no buy box on the page it falls back to the
  // default variant baked into the button. ----
  function initBundleAdd(btn) {
    // boot() runs on DOMContentLoaded AND on every shopify:section:load. Binding twice here
    // posts the cart twice — it showed up as quantity 2 of each line item.
    if (btn.dataset.lvBound) return;
    btn.dataset.lvBound = '1';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var picked = document.querySelector('[data-lv-buybox] .product-variant-id');
      var wandId = (picked && picked.value) || btn.getAttribute('data-lv-wand-variant');
      addToCart([wandId, btn.getAttribute('data-lv-bundle-variant')], btn);
    });
  }

  // ---- Click-to-play video (UGC tiles): poster until tapped, then plays with sound ----
  // Loading is staged so the page stays light but playback still starts fast:
  //   1. markup ships preload="none"  -> zero video bytes on first paint
  //   2. tile scrolls into view       -> preload="metadata" (headers + first frame only)
  //   3. pointer/touch intent         -> preload="auto" + load(), buffering starts BEFORE
  //                                      the tap completes, which removes most of the delay
  //   4. click                        -> play()
  // Steps 2 and 3 are the whole trick: by the time the click event fires the browser has
  // usually already buffered enough to start, so playback feels instant without the tile
  // costing anything at page load.
  function initVideo(wrap) {
    var video = wrap.querySelector('video');
    if (!video) return;
    var warmed = false;

    function warm() {
      if (warmed) return;
      warmed = true;
      video.preload = 'auto';
      video.load();
    }

    // 2. cheap metadata fetch once the tile is actually on screen
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          if (video.preload === 'none') video.preload = 'metadata';
          io.unobserve(e.target);
        });
      }, { rootMargin: '200px' });
      io.observe(wrap);
    } else {
      video.preload = 'metadata';
    }

    // 3. warm on intent. touchstart fires well before click on mobile; pointerenter
    //    covers desktop hover. passive so we never block scrolling.
    wrap.addEventListener('pointerenter', warm, { passive: true });
    wrap.addEventListener('touchstart', warm, { passive: true });

    // 4. play with sound (a real user gesture, so unmuted playback is allowed).
    //    Native controls give pause/scrub/volume for free.
    wrap.addEventListener('click', function () {
      if (wrap.classList.contains('is-playing')) return;
      warm();
      wrap.classList.add('is-playing');
      video.setAttribute('controls', '');
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }, { once: true });
  }

  // ---- Shared drag/swipe: touch + mouse. getIndex()/go(i) drive a flex track ----
  function addDrag(track, getIndex, go) {
    var startX = 0, dx = 0, dragging = false, width = 0;
    function down(x) {
      dragging = true; startX = x; dx = 0;
      width = track.offsetWidth || 1;
      track.style.transition = 'none';
    }
    function move(x) {
      if (!dragging) return;
      dx = x - startX;
      track.style.transform = 'translateX(' + (-getIndex() * 100 + (dx / width) * 100) + '%)';
    }
    function up() {
      if (!dragging) return;
      dragging = false;
      track.style.transition = '';
      var threshold = width * 0.15;
      if (dx > threshold) go(getIndex() - 1);
      else if (dx < -threshold) go(getIndex() + 1);
      else go(getIndex());
    }
    track.addEventListener('touchstart', function (e) { down(e.touches[0].clientX); }, { passive: true });
    track.addEventListener('touchmove', function (e) { move(e.touches[0].clientX); }, { passive: true });
    track.addEventListener('touchend', up);
    track.addEventListener('touchcancel', up);
    track.addEventListener('mousedown', function (e) { e.preventDefault(); down(e.clientX); });
    window.addEventListener('mousemove', function (e) { if (dragging) move(e.clientX); });
    window.addEventListener('mouseup', up);
  }

  // ---- Gallery: swipeable carousel + thumbnail nav ----
  function initGallery(root) {
    var track = root.querySelector('[data-lv-track]');
    if (!track) return;
    var count = track.children.length;
    if (!count) return;
    var thumbs = root.querySelectorAll('[data-lv-thumb-index]');
    var counter = root.querySelector('[data-lv-counter]');
    var index = 0;
    var ends = function () {};

    function go(i) {
      index = Math.max(0, Math.min(count - 1, i));
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', parseInt(t.getAttribute('data-lv-thumb-index'), 10) === index);
      });
      if (counter) counter.textContent = 'Slide ' + (index + 1) + ' of ' + count;
      // The thumb rail only shows ~4 at a time on mobile, so keep the active one in view.
      var active = thumbs[index];
      if (active && active.parentNode && active.parentNode.scrollWidth > active.parentNode.clientWidth) {
        var rail = active.parentNode;
        var target = active.offsetLeft - (rail.clientWidth - active.offsetWidth) / 2;
        rail.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
      }
      ends();
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-lv-thumb-index'), 10)); });
    });

    // Prev/next carets. No wrap-around: at either end the caret disables and greys out
    // so the control tells you where you are in the set.
    var prev = root.querySelector('[data-lv-prev]');
    var next = root.querySelector('[data-lv-next]');
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    ends = function () {
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === count - 1;
    };

    // Selecting a version swaps the first slide to that version's hero shot and rewinds
    // the carousel, so the gallery always opens on the product you just chose.
    document.addEventListener('lv:variant-change', function (e) {
      var hero = e.detail && e.detail.hero;
      if (hero && track.children[0]) {
        var slideImg = track.children[0].querySelector('img');
        if (slideImg) slideImg.src = hero;
        var thumbImg = thumbs[0] && thumbs[0].querySelector('img');
        if (thumbImg) thumbImg.src = hero;
      }
      go(0);
    });

    addDrag(track, function () { return index; }, go);
    go(0);
  }

  // ---- Testimonials: swipeable card carousel with dots ----
  function initTesti(root) {
    var track = root.querySelector('[data-lv-testi-track]');
    if (!track) return;
    var count = track.children.length;
    if (!count) return;
    var dots = root.querySelectorAll('[data-lv-testi-index]');
    var index = 0;

    function go(i) {
      index = Math.max(0, Math.min(count - 1, i));
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      dots.forEach(function (d) {
        d.classList.toggle('is-active', parseInt(d.getAttribute('data-lv-testi-index'), 10) === index);
      });
    }

    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-lv-testi-index'), 10)); });
    });
    addDrag(track, function () { return index; }, go);
    go(0);
  }

  // ---- Simple swap gallery (offer buy box): click a thumb → main image swaps ----
  function initSwapGallery(root) {
    var main = root.querySelector('[data-lv-gallery-main] img');
    var thumbs = root.querySelectorAll('[data-lv-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-lv-thumb');
        if (src) main.src = src;
        thumbs.forEach(function (o) { o.classList.toggle('is-active', o === t); });
      });
    });
  }

  // ---- Modal: a trigger opens the dialog named by data-lv-modal-open ----
  // Uses <dialog> so Esc-to-close, focus trapping and the backdrop are native.
  function initModal(trigger) {
    var dlg = document.getElementById(trigger.getAttribute('data-lv-modal-open'));
    if (!dlg) return;
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      if (typeof dlg.showModal === 'function') dlg.showModal();
      else dlg.setAttribute('open', '');
    });
    dlg.querySelectorAll('[data-lv-modal-close]').forEach(function (b) {
      b.addEventListener('click', function () { dlg.close(); });
    });
    // click the backdrop (i.e. the dialog element itself, outside its content) to dismiss
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
  }

  // ---- Version-linked images: swap art when the buy box announces a variant change ----
  // Each image carries data-lv-img-0/1/2 (Clear / Pro / Ultimate). Missing entries fall
  // back to index 0, so a version that reuses the default art needs no attribute.
  function initVariantImages(img) {
    var srcs = [0, 1, 2].map(function (i) { return img.getAttribute('data-lv-img-' + i); });
    document.addEventListener('lv:variant-change', function (e) {
      var next = srcs[e.detail.index] || srcs[0];
      if (next && img.getAttribute('src') !== next) img.setAttribute('src', next);
    });
  }

  // ---- Version-linked text: same idea as the images, but swaps innerHTML so headings
  // keep their <em> accent. Falls back to the index-0 copy. ----
  function initVariantText(el) {
    var txt = [0, 1, 2].map(function (i) { return el.getAttribute('data-lv-text-' + i); });
    document.addEventListener('lv:variant-change', function (e) {
      var next = txt[e.detail.index] || txt[0];
      if (next != null && el.innerHTML !== next) el.innerHTML = next;
    });
  }

  // ---- Price-bearing CTAs: a down-page button whose label quotes the price of the
  // version currently selected in the buy box. The element carries a template with a
  // [price] token (square brackets, not braces — a literal `}` would close the Liquid
  // output tag). The price string comes straight from the buy box, so it is whatever
  // Shopify Markets rendered for this visitor's currency. ----
  function initVariantPriceLabel(el) {
    var tpl = el.getAttribute('data-lv-price-tpl') || '';
    document.addEventListener('lv:variant-change', function (e) {
      var price = e.detail && e.detail.price;
      if (!price) return;
      var next = tpl.replace('[price]', price);
      if (el.textContent !== next) el.textContent = next;
    });
  }

  // ---- Version-gated blocks: hidden unless the selected version index is >= the
  // block's data-lv-min-version (Clear ships 4 electrodes, Pro/Ultimate add 2). ----
  function initVariantGate(el) {
    var min = parseInt(el.getAttribute('data-lv-min-version'), 10) || 0;
    document.addEventListener('lv:variant-change', function (e) {
      el.hidden = e.detail.index < min;
    });
  }

  // ---- Rating → reviews. Scrolls to the Loox section rather than linking, so it works
  // wherever that section sits in the template. ----
  function initScrollToReviews(btn) {
    btn.addEventListener('click', function () {
      var target = document.querySelector('[id*="__reviews"]')
                || document.querySelector('#looxReviews, .loox-reviews-default, [class*="loox"]');
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  // The theme's header is sticky, so every programmatic scroll has to clear it or the
  // target lands underneath.
  function headerHeight() {
    var head = document.querySelector('.shopify-section-group-header-group, header');
    return head ? head.getBoundingClientRect().height : 0;
  }

  // ---- Down-page CTAs scroll instead of navigating. ----
  // Every CTA below the fold is a "buy" button, but each one still carries a real href (the
  // product URL, or `#`) so it works with JS off and reads as a link to crawlers. With JS on,
  // navigating is wrong: it reloads the page just to land on the same buy box. Delegated at
  // the document so new sections need no wiring. Three cases:
  //   href="#section-id" → smooth-scroll to that element (the hero CTA aims at the carousel)
  //   href="#" / "" / this page's product → scroll to the buy box
  //   anything else, or a link marked data-lv-nav → left alone, navigates normally
  // `data-lv-nav` is what keeps the product-card grid working: those tiles link to OTHER
  // products and must still navigate.
  function initBuyScroll() {
    // boot() re-runs on every shopify:section:load; a delegated listener must bind once.
    if (document.documentElement.dataset.lvBuyScroll) return;
    document.documentElement.dataset.lvBuyScroll = '1';
    document.addEventListener('click', function (e) {
      // `[data-lv-buybox]` is the NATIVE buy box. The legacy pages (LED mask, collagen mask)
      // still run the base theme's `main-product` section, which has no such hook, so a
      // down-page CTA there used to be a silent no-op. Shopify always keys the main product
      // section `main`, hence the id suffix as the fallback anchor.
      var box = document.querySelector('[data-lv-buybox]')
             || document.querySelector('[id$="__main"], #shopify-section-main');
      var a = e.target.closest && e.target.closest('a.lv-btn');
      if (!a || a.closest('[data-lv-nav]')) return;
      if (box && box.contains(a)) return;
      var href = a.getAttribute('href') || '';

      // Named in-page anchor: scroll there, clear of the sticky header.
      if (href.length > 1 && href.charAt(0) === '#') {
        var anchor = document.getElementById(href.slice(1));
        if (!anchor) return;
        e.preventDefault();
        window.scrollTo({
          top: Math.max(0, anchor.getBoundingClientRect().top + window.scrollY - headerHeight() - 12),
          behavior: 'smooth'
        });
        return;
      }

      if (!box) return; // no buy box on this page — leave every link alone
      var selfLink = href === '' || href === '#' || href.indexOf('/products/') === 0;
      if (!selfLink) return;
      e.preventDefault();
      // The header is sticky, so scrollIntoView would slide the buy box under it.
      var offset = headerHeight();
      var top = box.getBoundingClientRect().top + window.scrollY - offset - 12;
      // Landing on the buy box's top edge leaves Add To Cart hanging just off the bottom on
      // a phone. Scroll far enough that the button is fully in frame, but never so far that
      // the version selector goes under the header — the point is to see all three at once.
      var atc = box.querySelector('.lv-ph__atc, .lv-of__atc');
      var picker = box.querySelector('.lv-ph__variants, .lv-of__variants');
      if (atc) {
        var reveal = atc.getBoundingClientRect().bottom + window.scrollY + 20 - window.innerHeight;
        var limit = picker
          ? picker.getBoundingClientRect().top + window.scrollY - offset - 12
          : reveal;
        top = Math.min(Math.max(top, reveal), limit);
      }
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    });
  }

  // Reveal animations hide their element until it scrolls in. That hidden state MUST be gated
  // on this class: if the script fails to load or errors, no `.lv-js` is ever set and every
  // revealed section renders plainly visible instead of as a blank white gap. Set at parse
  // time (the script is deferred, so this runs before the below-fold content is painted).
  document.documentElement.classList.add('lv-js');

  // Scroll-reveal. Adds `.is-in` the first time the element enters the viewport, then stops
  // observing — reveals are one-shot, they must never replay and re-animate on scroll-back.
  // Honours prefers-reduced-motion by revealing immediately, so the content is never gated
  // behind an animation a user has asked not to see.
  function initReveal(el) {
    // boot() re-runs on shopify:section:load and re-scans the whole document.
    if (el.dataset.lvRevealInit) return;
    el.dataset.lvRevealInit = '1';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
        !('IntersectionObserver' in window)) {
      el.classList.add('is-in');
      return;
    }
    var replay = !!el.closest('[data-lv-replay]');
    var COOLDOWN = 12000;
    var lastIn = 0;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          if (!replay) { e.target.classList.add('is-in'); io.unobserve(e.target); return; }
          if (Date.now() - lastIn >= COOLDOWN) { lastIn = Date.now(); e.target.classList.add('is-in'); }
        } else if (replay && Date.now() - lastIn >= COOLDOWN) {
          // Drop the class only once the cooldown has elapsed, so the ring is re-drawable
          // on the next approach without flickering during the scroll that leaves it.
          e.target.classList.remove('is-in');
        }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });
    io.observe(el);
  }

  // Count-up for stat numbers. Reads the target off the element's existing text so the real
  // value stays in the Liquid/schema (and is what a crawler or a no-JS visitor sees) rather
  // than being duplicated in a data attribute that can drift from the copy.
  function initCount(el) {
    // Re-reading textContent mid-animation would latch a partial value as the new target.
    if (el.dataset.lvCountInit) return;
    el.dataset.lvCountInit = '1';
    var raw = el.textContent.trim();
    var m = raw.match(/-?[\d.,]+/);
    if (!m) return;
    var target = parseFloat(m[0].replace(/,/g, ''));
    if (isNaN(target)) return;
    var prefix = raw.slice(0, m.index);
    var suffix = raw.slice(m.index + m[0].length);
    var decimals = (m[0].split('.')[1] || '').length;
    var grouped = m[0].indexOf(',') !== -1;

    function render(v) {
      var s = v.toFixed(decimals);
      if (grouped) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      el.textContent = prefix + s + suffix;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
        !('IntersectionObserver' in window)) return; // leave the final value in place

    // Deliberately NOT zeroed up front. If the observer never fires (offscreen forever, an
    // exception elsewhere, a headless capture), the element keeps showing its true value
    // instead of being frozen at 0 — a wrong number is far worse than a missing animation.
    // Replay is OPT-IN via [data-lv-replay] on an ancestor. Without it the count still runs
    // exactly once, so nothing else on the page starts re-animating as a side effect.
    var replay = !!el.closest('[data-lv-replay]');
    var COOLDOWN = 12000; // ms away from the viewport before a replay is allowed
    var lastRun = 0;
    var running = false;

    function run() {
      if (running) return;
      running = true;
      lastRun = Date.now();
      var start = null;
      var dur = 1100;
      (function step(ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        // easeOutCubic: fast start, settles gently on the final number
        render(target * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(step);
        else { render(target); running = false; }
      })(performance.now());
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          if (!replay) { io.unobserve(e.target); return run(); }
          // Only replay if it has been out of view long enough to be a genuine return,
          // never on the little intersection flickers of a single scroll pass.
          if (Date.now() - lastRun >= COOLDOWN) run();
        }
      });
    }, { threshold: 0.5 });
    io.observe(el);
  }

  // ---- Annotated wand callouts: one open at a time, none open initially ----
  // Clicking the open one closes it, so there is always a way back to the bare photo.
  function initWand(stage) {
    if (stage.dataset.lvWandInit) return;
    stage.dataset.lvWandInit = '1';
    var dots = stage.querySelectorAll('[data-lv-wand-dot]');
    var pops = stage.querySelectorAll('[data-lv-wand-pop]');
    var open = -1;

    function show(i) {
      open = i;
      dots.forEach(function (d) {
        var on = d.getAttribute('data-lv-wand-dot') === String(i);
        d.classList.toggle('is-on', on);
        d.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      pops.forEach(function (p) {
        p.classList.toggle('is-on', p.getAttribute('data-lv-wand-pop') === String(i));
      });
    }

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var i = parseInt(d.getAttribute('data-lv-wand-dot'), 10);
        show(open === i ? -1 : i);
      });
    });
  }

  // ---- Independent disclosure drawers (the science section) ----
  // Deliberately NOT single-open: each drawer toggles on its own. The height animation is
  // grid-template-rows 0fr->1fr, which transitions cleanly without measuring scrollHeight.
  // FAQ uses native <details> instead — it needs to be open for in-page search and print.
  function initDrawer(row) {
    if (row.dataset.lvDrawerInit) return;
    row.dataset.lvDrawerInit = '1';
    var btn = row.querySelector('[data-lv-drawer-toggle]');
    var panel = row.querySelector('[data-lv-drawer-panel]');
    if (!btn || !panel) return;
    // The first drawer ships open, marked in the Liquid so it is open before JS runs.
    var isOpen = row.classList.contains('is-open');
    btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    btn.addEventListener('click', function () {
      isOpen = !isOpen;
      row.classList.toggle('is-open', isOpen);
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  // ---- Scroll-linked progress fill (timeline, how-to) ----
  // BIDIRECTIONAL on purpose: un-fills on the way back up. The stat rings deliberately do
  // NOT use this — they are one-way, driven by initReveal instead. Don't unify them.
  //
  // Publishes a 0..1 ratio (not a pixel height) so CSS decides what to do with it and the
  // effect survives any change of section height. Items marked [data-lv-fill-item] light as
  // the playhead passes them, which is what makes the connector and the cards agree.
  function initFill(el) {
    if (el.dataset.lvFillInit) return;
    el.dataset.lvFillInit = '1';
    var prop = el.getAttribute('data-lv-fill') || '--tl-fill';
    var items = el.querySelectorAll('[data-lv-fill-item]');

    function lightAll() {
      el.style.setProperty(prop, '1');
      items.forEach(function (i) { i.classList.add('is-lit'); });
    }
    // With motion suppressed the section still has to READ as complete, so it ships lit.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return lightAll();

    var queued = false;
    function measure() {
      queued = false;
      var r = el.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      // A fixed playhead line in the lower-middle of the viewport. Progress is how far down
      // the element that line currently sits.
      var playhead = vh * 0.62;
      var p = (playhead - r.top) / Math.max(r.height, 1);
      p = Math.min(Math.max(p, 0), 1);
      el.style.setProperty(prop, String(p));
      items.forEach(function (i, n) {
        // The FIRST item ships lit: an all-grey list reads as disabled before you reach it,
        // and step 1 is true the moment the section is on screen.
        if (n === 0) return i.classList.add('is-lit');
        var ir = i.getBoundingClientRect();
        // Lit once the item's own marker (near its top) has passed the playhead, so a card
        // lights as it arrives rather than only when fully on screen.
        i.classList.toggle('is-lit', ir.top + Math.min(ir.height * 0.3, 110) <= playhead);
      });
    }
    function onScroll() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(measure);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    measure();
  }

  // ---- Snap rail prev/next: nudge by exactly one card ----
  // The rail itself scrolls natively (CSS scroll-snap); these buttons are an affordance on
  // top of it, so touch users keep momentum scrolling and the arrows stay in sync for free.
  function initRail(wrap) {
    if (wrap.dataset.lvRailInit) return;
    wrap.dataset.lvRailInit = '1';
    var rail = wrap.querySelector('[data-lv-rail]');
    if (!rail) return;
    var prev = wrap.querySelector('[data-lv-rail-prev]');
    var next = wrap.querySelector('[data-lv-rail-next]');

    function step() {
      var card = rail.firstElementChild;
      if (!card) return rail.clientWidth;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }
    function nudge(dir) {
      rail.scrollBy({ left: dir * step(), behavior: 'smooth' });
    }
    var marks = wrap.querySelectorAll('[data-lv-rail-mark]');
    function sync() {
      var max = rail.scrollWidth - rail.clientWidth - 1;
      if (prev) prev.disabled = rail.scrollLeft <= 0;
      if (next) next.disabled = rail.scrollLeft >= max;
      // Position markers: which card is parked at the snap point.
      if (marks.length) {
        // Only VISIBLE marks count — the electrode rail hides dots for electrodes the
        // selected variant does not ship, so a raw index would drift out of sync.
        var vis = [].filter.call(marks, function (m) { return !m.hidden; });
        if (!vis.length) return;
        var i = Math.round(rail.scrollLeft / step());
        if (i < 0) i = 0;
        if (i > vis.length - 1) i = vis.length - 1;
        vis.forEach(function (m, n) { m.classList.toggle('is-on', n === i); });
      }
    }
    if (prev) prev.addEventListener('click', function () { nudge(-1); });
    if (next) next.addEventListener('click', function () { nudge(1); });
    rail.addEventListener('scroll', sync, { passive: true });
    sync();
  }

  // Evergreen countdown to the visitor's OWN next midnight (luvia-countdown.liquid).
  // Deliberately has no end date: the target is recomputed from the local clock on every tick,
  // so it rolls over nightly on its own and can never render an expired timer. Using the shop's
  // timezone here would show the wrong number to most of the traffic.
  function initCountdown(el) {
    if (el.dataset.lvCountdownInit) return;
    el.dataset.lvCountdownInit = '1';
    var h = el.querySelector('[data-lv-cd-h]');
    var m = el.querySelector('[data-lv-cd-m]');
    var s = el.querySelector('[data-lv-cd-s]');
    if (!h || !m || !s) return;

    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var timer = null;

    function tick() {
      var now = new Date();
      // Local midnight tonight. Constructing from Y/M/D+1 (rather than adding 86400000) keeps it
      // correct across daylight-saving boundaries, where a "day" is 23 or 25 hours long.
      var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
      var left = Math.max(0, Math.floor((midnight - now) / 1000));
      h.textContent = pad(Math.floor(left / 3600));
      m.textContent = pad(Math.floor((left % 3600) / 60));
      s.textContent = pad(left % 60);
    }

    // Pause when the tab is hidden — an interval in a backgrounded tab is throttled to a crawl
    // and comes back stale, so re-sync on return instead of trusting the accumulated ticks.
    function start() { if (!timer) { tick(); timer = setInterval(tick, 1000); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });
    start();
  }

  // ---- Before/after reveal: mirror the range's value into the CSS custom property ----
  // The <input type="range"> already owns drag, touch, arrow keys and the announced value.
  // All that is left is telling CSS where the clip edge goes, so this stays one line of work.
  function initBeforeAfter(frame) {
    var range = frame.querySelector('.lv-ba__range');
    if (!range) return;
    function sync() { frame.style.setProperty('--lv-ba-pos', range.value + '%'); }
    range.addEventListener('input', sync);
    sync();
  }

  function boot() {
    initBuyScroll();
    document.querySelectorAll('[data-lv-ba]').forEach(initBeforeAfter);
    document.querySelectorAll('[data-lv-countdown]').forEach(initCountdown);
    document.querySelectorAll('[data-lv-wand]').forEach(initWand);
    document.querySelectorAll('[data-lv-drawer]').forEach(initDrawer);
    document.querySelectorAll('[data-lv-fill]').forEach(initFill);
    document.querySelectorAll('[data-lv-rail-wrap]').forEach(initRail);
    document.querySelectorAll('[data-lv-reveal]').forEach(initReveal);
    document.querySelectorAll('[data-lv-count]').forEach(initCount);
    document.querySelectorAll('[data-lv-scroll-to-reviews]').forEach(initScrollToReviews);
    document.querySelectorAll('[data-lv-text-0]').forEach(initVariantText);
    document.querySelectorAll('[data-lv-min-version]').forEach(initVariantGate);
    document.querySelectorAll('[data-lv-price-tpl]').forEach(initVariantPriceLabel);
    document.querySelectorAll('[data-lv-bundle-add]').forEach(initBundleAdd);
    document.querySelectorAll('[data-lv-img-0]').forEach(initVariantImages);
    document.querySelectorAll('[data-lv-modal-open]').forEach(initModal);
    document.querySelectorAll('[data-lv-buybox]').forEach(initBuybox);
    document.querySelectorAll('[data-lv-swap-gallery]').forEach(initSwapGallery);
    document.querySelectorAll('[data-lv-video]').forEach(initVideo);
    document.querySelectorAll('[data-lv-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-lv-testi]').forEach(initTesti);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-init when the theme editor injects/reloads a section
  document.addEventListener('shopify:section:load', boot);
})();
